import { RouteRecordRaw } from 'vue-router'
import { getPayrollValidCountries } from '@/micro/modules/version'
import { ApplicationVersion } from '@/micro/types/version.type'
import { APP_ENVIRONMENT } from '@/micro/utils/environment'

interface MagicLinkProps {
  type: 'login' | 'signup'
}

const loginRoutes: Array<RouteRecordRaw> = [
  {
    path: '/user/login',
    name: 'login',
    component: () => import('@/micro/views/login/LoginView.vue'),
  },
  {
    path: '/user/login/pos',
    name: 'login-pos',
    component: () => import('@/micro/views/login/LoginView.vue'),
  },
  {
    path: '/user/login/tpv',
    name: 'login-tpv',
    component: () => import('@/micro/views/login/LoginView.vue'),
  },
  {
    path: '/user/login/punto-venta',
    name: 'login-pv',
    component: () => import('@/micro/views/login/LoginView.vue'),
  },
  {
    path: '/user/login/nomina',
    name: 'login-payroll',
    component: () => import('@/micro/views/login/LoginView.vue'),
  },
  {
    path: '/user/login/country/:country',
    name: 'login-by-country',
    component: () => import('@/micro/views/login/LoginView.vue'),
  },
  {
    path: '/user/login/nomina/country/:country',
    name: 'login-payroll-by-country',
    component: () => import('@/micro/views/login/LoginView.vue'),
    beforeEnter: (to, from, next) => {
      const country = to.params.country as ApplicationVersion
      const validCountries = getPayrollValidCountries(APP_ENVIRONMENT)

      // Si el país no es válido para Nómina, redirigir a Colombia (país por defecto)
      if (!validCountries.includes(country)) {
        next({
          name: 'login-payroll-by-country',
          params: { country: 'colombia' },
          replace: true,
        })
      } else {
        next()
      }
    },
  },
  {
    path: "/user/login/magic-link",
    name: "magic-link-login",
    component: () => import('@/micro/views/magic-link/MagicLinkView.vue'),
    props: {
      type: 'login',
    } as MagicLinkProps,
  },
  {
    path: "/user/signup",
    name: "magic-link-session",
    component: () => import('@/micro/views/magic-link/MagicLinkSessionView.vue'),
  },
  {
    path: '/user/login/agent-access',
    name: 'agent-access',
    component: () => import('@/micro/views/agent-access/AgentAccessView.vue'),
  },
  {
    path: "/user/login/magic-link/error",
    name: "magic-link-error",
    component: () => import('@/micro/views/magic-link/MagicLinkErrorView.vue'),
  },
]

export default loginRoutes
